<b-modal v-model="modal_special_requirement_MVS3" size="md" :header-bg-variant="headerColor" header-text-variant="light"
  no-close-on-backdrop no-close-on-esc centered no-stacking>
  <!-- ヘッダー -->
  <template v-slot:header>
    <div class="text-center w-100">
      {{ headerTitle }}
    </div>
  </template>

  <!-- ボディ -->
  <template v-slot:default>
    <b-overlay :show="isLoading" opacity="0.3" spinner-variant="primary">
      <div class="container-fluid dialog-body">
        <div class="w-100">
          <div class="box-margin-right work-support-message">
            {{ workSupportMessage }}
          </div>
        </div>
        <!-- 待機画面: 機能選択リスト -->
        <cstm-table v-if="showFunctionList" id="cstm-table" useStripeStyle hasTabs useSort initSortDir="asc" rowSelect
          :items="functionTableItems" :columns="functionTableColumns" type="simple" @rowClicked="onSelectItem" />
      </div>
    </b-overlay>
  </template>

  <!-- フッター -->
  <template v-slot:footer>
    <div class="w-100 text-center">
      <b-button v-if="showButtonOk" size="sm" :disabled="isDisableOk" variant="primary" @click="onOkClicked"
        class="mx-2">
        {{ $t('message.common_button_ok') }}
      </b-button>
      <b-button v-if="showButtonFinish" size="sm" :disabled="isLoading" variant="primary" @click="stopProcess"
        class="mx-2">
        {{ $t('individual.label_button_finish') }}
      </b-button>
      <b-button v-if="showButtonCancel" size="sm" :disabled="isLoading" variant="outline-primary"
        @click="onCancelClicked" class="mx-2">
        {{ $t('message.common_button_cancel') }}
      </b-button>
    </div>
  </template>
</b-modal>